const common = {
  Test: '測試',
  Save: '储存',
};

export default common;
